import { Alert, Box, Link, Popover, Typography } from '@mui/material'
import getEnv from 'utilities/getEnv'
import { useTranslation } from 'react-i18next'

function VersionWarningPopup({
    open,
    onClose,
    anchorEl,
    type,
    isUncompatibleVersion,
    isOlderLatestVersion,
    version,
    compatibilityVersion,
    latestVersion,
}: {
    type: string
    anchorEl: any
    onClose: () => void
    open: boolean
    version: string
    compatibilityVersion: string
    latestVersion: string
    isOlderLatestVersion: boolean
    isUncompatibleVersion: boolean
}) {
    const { t } = useTranslation()

    const isUncompatibleVersionContext = () => {
        return (
            <Alert severity="warning">
                <Typography className="textCapitalize" fontWeight={600}>
                    {type} Hardware Agent Warning
                </Typography>
                <Box>
                    <Typography>
                        {t('hwAgent.uncompatible_version_warning_message', {
                            currentVersion: version,
                            compatibilityVersion,
                        })}
                        <span style={{ marginLeft: 5 }}>
                            <Link
                                href={getEnv('REACT_APP_HARDWARE_AGENT')}
                                target="_blank"
                            >
                                {t('hwAgent.download_the_latest_version')}
                            </Link>
                        </span>
                    </Typography>
                </Box>
            </Alert>
        )
    }
    const isOlderVersionContext = () => {
        return (
            <Alert severity="info">
                <Typography className="textCapitalize" fontWeight={600}>
                    {type} Hardware Agent Warning
                </Typography>
                <Box>
                    <Typography>
                        {t('hwAgent.older_latest_version_warning_message', {
                            currentVersion: version,
                            latestVersion: latestVersion,
                        })}

                        <span style={{ marginLeft: 5 }}>
                            <Link
                                href={getEnv('REACT_APP_HARDWARE_AGENT')}
                                target="_blank"
                            >
                                {t('hwAgent.download_the_latest_version')}
                            </Link>
                        </span>
                    </Typography>
                </Box>
            </Alert>
        )
    }
    return (
        <Popover
            onClose={onClose}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
        >
            {isUncompatibleVersion ? (
                isUncompatibleVersionContext()
            ) : isOlderLatestVersion ? (
                isOlderVersionContext()
            ) : (
                <></>
            )}
        </Popover>
    )
}
export default VersionWarningPopup
